import {Input, withStyles} from '@yandex-taxi/go-web-components'

/** @deprecated use `import {Input} from '@yandex-delivery/blocks'` */
export default withStyles(
  theme => ({
    root: {
      [theme.breakpoints.down('xs')]: {
        // костыли для мобилки
        // почему-то на мобилке на инпут приходилось кликать дважды, чтобы зафокусить
        '&:hover .MuiInputAdornment-root': {
          visibility: 'hidden',
        },
      },
    },
  }),
  {name: 'LFInput'},
)(Input)
